var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 39,
    viewBox: "0 0 44 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 5.17676,
    y: 2.58789,
    width: 33.6471,
    height: 33.6471,
    rx: 16.8235,
    fill: "#FFA6A6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 25.8824,
    height: 25.8824,
    rx: 12.9412,
    transform: "matrix(1 0 0 -1 9.49023 25.8828)",
    fill: "#F34D4D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 25.8824,
    height: 25.8824,
    rx: 12.9412,
    transform: "matrix(1 0 0 -1 9.49023 38.8232)",
    fill: "#4FCB72"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 25.8824,
    height: 25.8824,
    rx: 12.9412,
    transform: "matrix(1 0 0 -1 0 32.7842)",
    fill: "#2A4863"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 25.8824,
    height: 25.8824,
    rx: 12.9412,
    transform: "matrix(1 0 0 -1 18.1177 32.7842)",
    fill: "#612341"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d214bfb97214aa1e7bb6648c2db6cd41.svg";
export { ForwardRef as ReactComponent };